// A place for common buttons to live between the single
// date picker and the range picker.
// @flow
import React from 'react';
import IconButton from 'material-ui/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

export function LeftButton(props: any) {
    return (
        <IconButton {...props}>
            <KeyboardArrowLeft />
        </IconButton>
    );
}

export function RightButton(props: any) {
    return (
        <IconButton {...props}>
            <KeyboardArrowRight />
        </IconButton>
    );
}



// WEBPACK FOOTER //
// ./src/view/analytics/DatePickerCommonButtons.jsx